import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { initNativeBridge } from "./lib/nativeBridge";

function App() {
  useEffect(() => {
    initNativeBridge();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
